import {
  getFunctions,
  connectFunctionsEmulator,
  httpsCallable,
  type Functions,
} from 'firebase/functions'
import { getFirebaseApp } from './app'
import { useEmulator } from '@/config/env'
import { FUNCTIONS_REGION } from '@/config/constants'

/* FirebaseFunctions.instanceFor(region: 'europe-west1') — the region pin is
 * mandatory: the deployed callables exist ONLY in europe-west1. */

let fns: Functions | null = null

function getFns(): Functions {
  if (!fns) {
    fns = getFunctions(getFirebaseApp(), FUNCTIONS_REGION)
    if (useEmulator) {
      connectFunctionsEmulator(fns, '127.0.0.1', 5001)
    }
  }
  return fns
}

/** sendReassurance({userId, alertRef: <FULL PATH, not id>}) -> void.
 * Success == no exception; the response body is empty and the original
 * stores `result` into a never-read variable. */
export async function callSendReassurance(payload: {
  userId: string
  alertRef: string
}): Promise<void> {
  await httpsCallable(getFns(), 'sendReassurance')(payload)
}

/** getDirections({origin: 'lat,lng', destination: 'lat,lng', mode, language?}).
 * `language` localizes the API's duration.text; optional and ignored by the
 * pre-update deployed function — safe to send unconditionally. */
export async function callGetDirections(payload: {
  origin: string
  destination: string
  mode: 'walking' | 'bicycling' | 'driving'
  language?: string
}): Promise<{
  distance?: { text?: string; value?: number }
  duration?: { text?: string; value?: number }
  polyline?: Array<{ lat: number; lng: number }>
} | null> {
  const res = await httpsCallable(getFns(), 'getDirections')(payload)
  return (res.data ?? null) as Awaited<ReturnType<typeof callGetDirections>>
}
